module.exports = __webpack_public_path__ + "static/img/cca-4.009cdab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/contact/cca-4.png
// module id = 962
// module chunks = 0